const convertPrice = (price: any | number) =>
  Math.round(Number(price)).toLocaleString();
export default convertPrice;

export function roundToNearestThousand(number: number) {
  return Math.ceil(number / 1000) * 1000;
}

export function roundToMaxDecimals(number: number, decimals = 3): number {
  return Math.round(number * 10 ** decimals) / 10 ** decimals;
}
